import React from 'react';
import PropTypes from 'prop-types';

import { useAuth } from 'hooks/useAuth';
import { usePusher } from 'hooks/usePusher';
import { useDisclosure } from '@mantine/hooks';

import { ActionIcon, Button } from '@mantine/core';
import { PublishMenuModal } from 'components/Modals/PublishMenuModal';

import DialogModal from 'components/Modals/DialogModal/DialogModal';
import { PublishIconSm } from '@chownow/pantry/icons';

export default function MenuPublishButton({
  checkMenuTouched,
  disabled,
  menu,
  iconButton,
  handleSave,
}) {
  const integrations = menu.integrations ?? [];

  const { channels } = usePusher();

  const [publishModalOpened, publishModalHandlers] = useDisclosure(false);
  const [dialogModalOpened, dialogModalHandlers] = useDisclosure(false);

  const handlePublishClick = () => {
    if (checkMenuTouched) {
      const hasBeenTouched = checkMenuTouched();
      if (hasBeenTouched) {
        dialogModalHandlers.open();
        return;
      }
    }
    publishModalHandlers.open();
  };

  const {
    companies,
    merchants,
    flags: { PUBLISH_LOCKED },
  } = useAuth();

  const MenuPublishedToAll = integrations.every(integration => integration.status === 'published');

  const isButtonDisabled =
    (!integrations.length && import.meta.env.VITE_TRANSACTIONS_ENABLED === 'false') ||
    menu.enabled === false ||
    disabled ||
    PUBLISH_LOCKED ||
    MenuPublishedToAll;

  const onConfirmSave = didSave => {
    if (didSave) {
      handleSave();
    }
    dialogModalHandlers.close();
  };

  return (
    <>
      {iconButton ? (
        <ActionIcon
          variant="ghost"
          onClick={publishModalHandlers.open}
          disabled={isButtonDisabled}
          h="var(--dimension-sm)"
          w="var(--dimension-sm)"
        >
          <PublishIconSm />
        </ActionIcon>
      ) : (
        <Button
          size="md"
          disabled={isButtonDisabled}
          onClick={handlePublishClick}
          w="140"
          style={{ flexGrow: 1 }}
        >
          Publish
        </Button>
      )}
      <PublishMenuModal
        opened={publishModalOpened}
        close={publishModalHandlers.close}
        channels={channels}
        companies={companies}
        menu={menu}
        merchants={merchants}
      />
      <DialogModal
        opened={dialogModalOpened}
        close={dialogModalHandlers.close}
        title="Save Your Edits"
        message="To publish the menu, please save your recent edits first."
        confirmLabel="Save"
        cancelLabel="Cancel"
        onClose={onConfirmSave}
      />
    </>
  );
}

MenuPublishButton.propTypes = {
  checkMenuTouched: PropTypes.func,
  disabled: PropTypes.bool,
  handleSave: PropTypes.func,
  iconButton: PropTypes.bool,
  menu: PropTypes.shape({
    enabled: PropTypes.bool,
    integrations: PropTypes.arrayOf(
      PropTypes.shape({
        status: PropTypes.string,
      }),
    ),
  }),
};
